export default __webpack_public_path__ + "static/media/Arrowback.682f30c4.svg";